import Body from './BlankTemplate/Body'
// Most Read on Tellimer
import MostReadOnTellimerOverview from './MostReadOnTellimer/Overview'
import MostReadOnTellimerSecondAndFifthArticles from './MostReadOnTellimer/SecondAndFifthArticles'
// Generic
import GenericOverview from './Overview'
import GenericPreview from './Preview'
// TellimerToday
import TellimerTodayArticles from './TellimerToday/Articles'
import TellimerTodayChooseType from './TellimerToday/ChooseType'
import TellimerTodayEphemera from './TellimerToday/Ephemera'
// TellimerToday Weekend
import TellimerTodayWeekendChooseType from './TellimerTodayWeekend/ChooseType'
import TellimerTodayWeekendArticle from './TellimerTodayWeekend/Articles'
import TellimerTodayWeekendEphemera from './TellimerTodayWeekend/Ephemera.vue'

// Weekly Round-up
import WeeklyRoundUpEphemera from './WeeklyRoundUp/Ephemera'
import WeeklyRoundUpHighlights from './WeeklyRoundUp/Highlights'
import WeeklyRoundUpOverview from './WeeklyRoundUp/Overview'

// // Daily Equity Note
import TellimerMarketsBriefingOverview from './TellimerMarketsBriefing/Overview'
import TellimerMarketsBriefingArticles from './TellimerMarketsBriefing/Articles'
import TellimerMarketsBriefingEphemera from './TellimerMarketsBriefing/Ephemera'

export default {
  'default': [
    {
      name: 'overview',
      title: 'Overview',
      component: GenericOverview,
    },
  ],
  'blank-template': [
    {
      name: 'overview',
      title: 'Overview',
      component: GenericOverview,
    },
    {
      name: 'body',
      title: 'Body',
      component: Body,
    },
    {
      name: 'preview',
      title: 'Preview & Publish',
      component: GenericPreview,
    },
  ],
  'end-of-day-wrap': [
    {
      name: 'overview',
      title: 'Overview',
      component: GenericOverview,
    },
    {
      name: 'body',
      title: 'Body',
      component: Body,
    },
    {
      name: 'preview',
      title: 'Preview & Publish',
      component: GenericPreview,
    },
  ],
  'friday-five': [
    {
      name: 'overview',
      title: 'Overview',
      component: MostReadOnTellimerOverview,
    },
    {
      name: 'secondAndFifthArticles',
      title: '2nd - 5th Articles',
      component: MostReadOnTellimerSecondAndFifthArticles,
    },
    {
      name: 'preview',
      title: 'Preview & Publish',
      component: GenericPreview,
    },
  ],
  'weekly-round-up': [
    {
      name: 'overview',
      title: 'Overview',
      component: WeeklyRoundUpOverview,
    },
    {
      name: 'highlights',
      title: 'Highlights',
      component: WeeklyRoundUpHighlights,
    },
    {
      name: 'ephemera',
      title: 'Ephemera',
      component: WeeklyRoundUpEphemera,
    },
    {
      name: 'preview',
      title: 'Preview & Publish',
      component: GenericPreview,
    },
  ],
  'tellimer-today': [
    {
      name: 'overview',
      title: 'Choose Type',
      component: TellimerTodayChooseType,
    },
    {
      name: 'articles',
      title: 'Articles',
      component: TellimerTodayArticles,
    },
    {
      name: 'ephemera',
      title: 'Ephemera',
      component: TellimerTodayEphemera,
    },
    {
      name: 'preview',
      title: 'Preview & Publish',
      component: GenericPreview,
    },
  ],
  'tellimer-today-weekend-edition': [
    {
      name: 'overview',
      title: 'Choose Type',
      component: TellimerTodayWeekendChooseType,
    },
    {
      name: 'articles',
      title: 'Articles',
      component: TellimerTodayWeekendArticle,
    },
    {
      name: 'ephemera',
      title: 'Ephemera',
      component: TellimerTodayWeekendEphemera,
    },
    {
      name: 'preview',
      title: 'Preview & Publish',
      component: GenericPreview,
    },
  ],
  'tellimer-markets-briefing': [
    {
      name: 'overview',
      title: 'Type & Marketing',
      component: TellimerMarketsBriefingOverview,
    },
    {
      name: 'summaries',
      title: 'Today’s summaries',
      component: TellimerMarketsBriefingArticles,
    },
    {
      name: 'ephemera',
      title: 'Ephemera',
      component: TellimerMarketsBriefingEphemera,
    },
    {
      name: 'preview',
      title: 'Preview & Publish',
      component: GenericPreview,
    },
  ],
}
